import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=0c6f66c2"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c6f66c2')) {
      api.createRecord('0c6f66c2', component.options)
    } else {
      api.reload('0c6f66c2', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=0c6f66c2", function () {
      api.rerender('0c6f66c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/bidDocumentation/Main.vue"
export default component.exports